/*
 *  Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ReactNode } from "react";
import { When } from "react-if";
import { useToggle } from "react-use";
import { Box, FlexContainer, theme } from "@nordcloud/gnui";
import { ExpandIcon } from "../Styled";
import { ClearButton, FilterItemWrapper } from "./styles";
import { getClearSelectionsText } from "./utils";

type Props = {
  children: ReactNode;
  name: string;
  onClear: () => void;
  isSelected?: boolean;
  selectedOptions?: string[];
  isExpandedInitially?: boolean;
};

export function FilterWrapper({
  children,
  name,
  onClear,
  isSelected = false,
  selectedOptions,
  isExpandedInitially,
}: Props) {
  const [isExpanded, toggleIsExpanded] = useToggle(
    isExpandedInitially ?? false
  );

  return (
    <Box
      boxStyle="lightGrey"
      marginTop={theme.spacing.spacing02}
      padding={0}
      css={{
        "&:hover": {
          backgroundColor: !isExpanded
            ? theme.color.background.ui04
            : undefined,
        },
      }}
    >
      <FilterItemWrapper
        justifyContent="space-between"
        isFilterSelected={isSelected}
      >
        <FlexContainer>
          <ExpandIcon
            name="chevronDown"
            title="chevronDown"
            isExpanded={isExpanded}
            css={{
              marginRight: theme.spacing.spacing00,
            }}
            onClick={toggleIsExpanded}
          />
          {name}
        </FlexContainer>
        <FlexContainer>
          <When condition={isSelected}>
            <ClearButton severity="low" onClick={onClear}>
              {getClearSelectionsText(selectedOptions)}
            </ClearButton>
          </When>
        </FlexContainer>
      </FilterItemWrapper>
      <When condition={isExpanded}>
        <div css={{ padding: theme.spacing.spacing02 }}>{children}</div>
      </When>
    </Box>
  );
}
